import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { ServiceDetails, ServiceViewModel } from '../business-entities/service-view-model';
import { ServiceDataService } from '../data-services/servicesData.service';
import { ServiceListRequestModel } from '../business-entities/service-list-request-model';
import { DealerServiceFilterModel } from 'projects/Widget/src/app/business-entities/dealer-service-filter-model';

@Injectable({
    providedIn: 'root'
})

export class ServicesService {
    serviceId;
    dealerServiceList: ServiceViewModel[];
    serviceList: ServiceViewModel;
    serviceDetails: ServiceDetails;
    registrationDate:any;
    engineTypeCode:any;
    vehicleTypeCode:any;
    companyMakeCode:any;
    model:string;
    previousKilometer:any;
    dealerId:any;
    SelectedServices: ServiceViewModel[] = [];
    searchService:string;
    name:string;
    serviceNo:string;
    serviceCategoryName:string;
    competenceName:string;
    locationCode: string;
    customerNo:string;

    serviceListRequest: ServiceListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            statusId: 0,
            cultureCode: '',
            isForDropDown: false,
            syncId: 0,
            name:'',
            serviceNo:'',
            serviceCategoryName:'',
            competenceName:'',
            isNeedAttention:false,
            isDiaplyPriceInWidget: false,
            isFixedPrice:false,
            isAdditionalCustomerComment:false,
            hasChecklist:false,
            sourceId:0,
        }
    constructor(private service: ServiceDataService) {
    }

    async getService(language: string, status: number, isForDropDown = false) {
        await this.service
            .getService(language, status, isForDropDown)
            .then(
                (res: GenericResponse<Array<ServiceViewModel>>) => {
                    this.dealerServiceList = res.responseObject;
                }
            );

        return this.dealerServiceList;
    }

    async getServiceList(serviceListRequest: any) {
        await this.service.getServiceList(serviceListRequest).then(
            (res: GenericResponse<Array<ServiceViewModel>>) => {
                this.dealerServiceList = res.responseObject;
            }
        );

        return this.dealerServiceList;
    }

    AddUpdateService(ServiceModel: any): Promise<GenericResponse<any>> {
        return this.service.AddUpdateService(ServiceModel);
    }

    async GetServiceById(ServiceId: number) {
        await this.service
            .GetServiceById(ServiceId)
            .then(
                (res: GenericResponse<ServiceDetails>) => {
                    this.serviceDetails = res.responseObject;
                }
            );
        return this.serviceDetails;
    }

    getServiceCategory(language: string) {
        return this.service.getServiceCategory(language);
    }

    getCompetence(status: number) {
        return this.service.getCompetence(status);
    }

    deleteService(Id: number) {
        return this.service.deleteService(Id);
    }
    GetServiceTimeDetails(ServiceId: number) {
        return this.service.GetServiceTimeDetails(ServiceId);
    }

    GetServicesByDealerId(dealerServiceFilterModel: DealerServiceFilterModel): Promise<any> {
        return this.service.GetServicesByDealerId(dealerServiceFilterModel);
    }
    getDiagnoseCheckListForService(language: string) {
        return this.service.getDiagnoseCheckListForService(language);
    }
}
